import { render, staticRenderFns } from "./patternConfiguratio.vue?vue&type=template&id=d2024b42&scoped=true"
import script from "./patternConfiguratio.vue?vue&type=script&lang=js"
export * from "./patternConfiguratio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2024b42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2024b42')) {
      api.createRecord('d2024b42', component.options)
    } else {
      api.reload('d2024b42', component.options)
    }
    module.hot.accept("./patternConfiguratio.vue?vue&type=template&id=d2024b42&scoped=true", function () {
      api.rerender('d2024b42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/patternConfiguratio.vue"
export default component.exports